module.exports = __webpack_public_path__ + "static/img/product1.2f96630.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/black/product1.png
// module id = k6tj
// module chunks = 0